module.exports = __webpack_public_path__ + "static/media/logo_modoo.3f2f9580.png";